// extracted by mini-css-extract-plugin
module.exports = {"logoShadow":"Navbar_logoShadow__EU7Kg","nav":"Navbar_nav__1oBjZ","navbarHeader":"Navbar_navbarHeader__XytJ_","logo":"Navbar_logo__YNqJh","phoneCall":"Navbar_phoneCall__kQj2Q"};